import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

const SERVICE_NAME = "FobInvoicePriceService.asmx";

@Injectable({
  providedIn: "root",
})
export class FobInvoicePriceService {
  constructor(private http: HttpUtilService) {}

  getInvoiceNoList(): Observable<any> {
    return this.http.get(`/${SERVICE_NAME}/GetInvoiceNoList`);
  }

  getPurchaseInvoiceList(purchaseInvNo: string): Observable<any> {
    const encodedInvNo = encodeURIComponent(`"${purchaseInvNo}"`);
    return this.http.get(`/${SERVICE_NAME}/GetPurchaseInvoiceList?purchaseInvNo=${encodedInvNo}`);
  }

  updateVehiclePrice(model: any): Observable<any> {
    const payload = { model: { __type: "KAPS.Model.Autopac.CrmFobInvoicePrice", ...model } };
    return this.http.post(`/${SERVICE_NAME}/UpdateVehiclePrice`, payload);
  }
}
